<cm-inspector-section>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot
            [node]="$node()"
            [overwrittenValue]="$parameters().parameters.type"
            (updatedOverwrittenValue)="changeType($event)"
            [key]="'parameters'"
            [subKey]="['type']"
            [label]="'Type'"
            [selectionPossibilities]="typeSelectionPossibilities"
        ></cm-value-slot>

        @if ($parameters().parameters.type === "MattressComponentGraphGeneratorUnitRepeat1D") {
            <cm-value-slot [node]="$node()" [key]="'parameters'" [subKey]="['unitGraph']" [label]="'Unit Graph'"></cm-value-slot>
            <cm-value-slot [node]="$node()" [key]="'parameters'" [subKey]="['unitCount']" [label]="'Unit Count'"></cm-value-slot>
            <cm-value-slot [node]="$node()" [key]="'parameters'" [subKey]="['unitIdPrefix']" [label]="'Unit ID Prefix'"></cm-value-slot>
            <cm-value-slot [node]="$node()" [key]="'parameters'" [subKey]="['baseGraph']" [label]="'Base Graph'"></cm-value-slot>
        }
    </ng-container>
</cm-inspector-section>

@if ($parameters().parameters.type === "MattressComponentGraphGeneratorUnitRepeat1D") {
    <cm-inspector-section class="cm-unit-interface-section">
        <ng-container cm-title>Unit Interface</ng-container>
        <ng-container cm-content>
            <cm-mattress-component-instance-interface-inspector
                [node]="$node()"
                [componentDescriptors]="$componentDescriptors()"
                [templateDescriptors]="$templateDescriptors()"
                [inputParameterProvider]="$inputParameterProvider()"
                (updateComponentInstanceParameter)="updateUnitInputParameter($event.key, $event.value)"
            ></cm-mattress-component-instance-interface-inspector>
            @if ($outputDescriptorsEntries().length > 0) {
                <cm-toggle [toggle]="$showOutputsIfUnitCountZero()" (toggleChange)="$showOutputsIfUnitCountZero.set($event)">
                    <ng-container cm-text>Outputs for unit count zero</ng-container>
                </cm-toggle>
                @if ($showOutputsIfUnitCountZero()) {
                    @for (descriptorEntry of $outputDescriptorsEntries(); track descriptorEntry.descriptor.props.id) {
                        <cm-value-slot
                            [node]="$node()"
                            [key]="'parameters'"
                            [label]="descriptorEntry.descriptor.props.name"
                            [schema]="descriptorEntry.schema"
                            [overwrittenValue]="descriptorEntry.value"
                            (updatedOverwrittenValue)="updateOutputIfUnitCountZero(descriptorEntry, $event)"
                        ></cm-value-slot>
                    }
                }
            }
        </ng-container>
    </cm-inspector-section>
}
